import { MainTheme } from './MainTheme';

export const Themes = {
  MainTheme
};

export default Themes;
